import React from 'react';

const FillTheGap = ({
  contentHTML,
  value = [],
  onChange,
  className = '',
  readOnly,
}) => {
  // split by <select> tags
  const parts = contentHTML.includes('<select')
    ? contentHTML.split(/(<select[\s\S]*?<\/select>)/g)
    : [];

  console.log({ parts });

  let selectIndex = 0;

  if (parts.length === 0) {
    return (
      <span className="text-danger">
        Something went wrong with the question
      </span>
    );
  }

  return (
    <div className={className}>
      {parts.map((part, index) => {
        if (part.startsWith('<select')) {
          const options = [...part.matchAll(/<option.*?>(.*?)<\/option>/g)].map(
            (match) => match[1],
          );

          const currentIndex = selectIndex++;

          return (
            <select
              key={`select-${index}`}
              value={value[currentIndex] || ''}
              className="gap-select mx-1"
              disabled={readOnly}
              onChange={(e) => {
                if (readOnly) return;
                const newValues = [...value];
                newValues[currentIndex] = e.target.value;
                onChange(newValues);
              }}
            >
              {options.map((opt, i) => (
                <option key={`option-${i}`} value={opt}>
                  {opt}
                </option>
              ))}
            </select>
          );
        }
        return <span key={index} dangerouslySetInnerHTML={{ __html: part }} />;
      })}
    </div>
  );
};

export default FillTheGap;
